<template>

<span>

  <form v-if="!loggedUser">

    <div class="columns is-multiline is-centered box">

      <!-- User -->
      <h2>{{$t('booking.user_info.user.header')}}</h2>
      <div class="column">

        <!-- FirstName -->
        <v-text-field
                v-model="user.firstName"
                :rules="[v => !!v || 'Name is required']"
                :label="$t('booking.user_info.user.first_name_label')"
                required>
        </v-text-field>
        <!-- LastName -->
        <v-text-field
                v-model="user.lastName"
                :rules="[v => !!v || 'Last name is required']"
                :label="$t('booking.user_info.user.last_name_label')"
                required>
        </v-text-field>

        <!-- PhoneNumber -->
          <v-text-field
                  v-model="user.phoneNumber"
                  :rules="[v => !!v || 'Phone number is required']"
                  :label="$t('booking.user_info.user.phone_number_label')"
                  :placeholder="$t('booking.user_info.user.phone_number_placeholder')"
          >
          </v-text-field>

        <!-- Email -->
        <v-text-field
                v-model="user.email"
                type="email"
                :rules="[v => !!v || $t('shared.emailRequired')]"
                :label="$t('booking.user_info.user.email_label')"
                required>
        </v-text-field>

        <v-text-field
                v-model="user.password"
                :rules="[v => !!v || 'Password is required']"
                :label="$t('shared.login.pass')"
                :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPass = !showPass"
                required
                :type="showPass ? 'text' : 'password'"
        ></v-text-field>

      </div>
      <v-btn v-on:click="displayAdditionelFields = !displayAdditionelFields">
        {{$t('booking.user_info.display')}}
      </v-btn>
      <span v-if="displayAdditionelFields">
        <br><br>

        <UserExtratInfo v-bind:user="user"></UserExtratInfo>

        </span>
    </div>
    <!-- submit button -->
    <div class="text-center">
      <v-btn rounded color="primary" type="submit" @click="validateAndSubmit()" style="text-align: center">
        &nbsp;{{$t('booking.user_info.user.header')}}
      </v-btn>
    </div>
  </form>
</span>

</template>

<script>
  import { nationalities, countries } from '@/shared/data';
  import { Sexe } from '@/shared/models';
  import { AuthApi } from '../services/api/auth'
  import { mapGetters } from 'vuex'
  import { UsersApi } from '../services/api/users'

  export default {
    name: 'CreateUser',
    props: ['redirectUrl'],
    data () {
      return {
        user: { driverInformation: {}, address: {} },
        showPass: false,
        error: null,
        displayAdditionelFields: false
      };
    },

    methods: {
      validateAndSubmit () {
        console.debug("Createuser", this.user,this.redirectUrl)
        UsersApi.createUser(this.user)
          .then(data => {
            console.debug("CreateUser data", data.JSESSIONID );
            this.$root.bar.success({message: "User Created"});

            this.$router.push({ query: { token: data.JSESSIONID } }).then(data => {
              console.log("Push",data)
              if (this.redirectUrl) {
                this.$router.push(this.redirectUrl);
              }else {
                this.$router.push(this.$route.path);
              }
            })
          })
          .catch(error => {
            console.error("LoginCreate", error)
            this.$root.bar.success({message: error.message});
          })
          .finally({})
      }
    },
    computed: {
      ...mapGetters({loggedUser: 'main/loggedUser'})
    },
    components: {}
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  @media (min-width: 960px) {
    .container {
      width: 66rem;
    }

    .padding-like-field {
      padding: 5.12rem 0 0 0;
    }

    .box {
      margin: 1rem 2rem !important;
    }

    .padding-comment {
      padding: 1rem 10rem !important;
    }
  }

  .padding-top {
    padding-top: 4rem;
  }

  .padding-comment {
    padding: 0.8rem;
  }

  .box {
    margin: 0.3rem;
  }


</style>
